import { initializeApp } from "firebase/app";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBypXY4iSzSsgvADjLcFPs3LpOHDS61VWI",
  authDomain: "instaclone-dd1d4.firebaseapp.com",
  projectId: "instaclone-dd1d4",
  storageBucket: "instaclone-dd1d4.appspot.com",
  messagingSenderId: "590744098194",
  appId: "1:590744098194:web:c11cee465327155b2a5d4b"
};

export const app = initializeApp(firebaseConfig);
export const storage = getStorage();
export const db = getFirestore(app);